module.exports = App.Promo = DS.Model.extend
  # timestamps
  created_at: DS.attr 'date'
  updated_at: DS.attr 'date'

  name:              DS.attr 'string'
  description:       DS.attr 'string'
  offer_description: DS.attr 'string'
  code:              DS.attr 'string'
  invalid_code_message: DS.attr 'string'
  promo_url: DS.attr 'string'

  # одноразовая акция
  once_only:  DS.attr 'boolean'

  # выключить/включить
  is_working: DS.attr 'boolean', defaultValue: true

  # срок действия акции
  actual_from: DS.attr 'date'
  actual_till: DS.attr 'date'

  # выключить/включить расписание
  timetable_enabled: DS.attr 'boolean'
  timetables: DS.attr 'timetable'

  timetable_for_asap_only: DS.attr 'boolean', defaultValue: false
  timetable_for_order_time: DS.attr 'boolean', defaultValue: false

  # акция к дню рождения
  for_birthday:     DS.attr 'boolean', defaultValue: false
  before_birthday:  DS.attr 'number'
  after_birthday:   DS.attr 'number'


  # условия на сумму и номер заказа
  order_sum:        DS.attr 'number'
  order_nth:        DS.attr 'number'
  repeatable_bonus: DS.attr 'boolean'

  for_new_client:   DS.attr 'boolean'

  is_delivery:      DS.attr 'boolean'
  is_takeaway:      DS.attr 'boolean'
  is_dine_in:       DS.attr 'boolean'
  inversed_delay:   DS.attr 'boolean'
  disposable:       DS.attr 'boolean'
  for_referral:     DS.attr 'boolean'
  free_delivery:    DS.attr 'boolean'


  priority:         DS.attr 'number'
  is_exclusive:     DS.attr 'boolean'


  issue_enabled:              DS.attr 'boolean'
  issue_code_length:          DS.attr 'number'
  issue_code_ttl:             DS.attr 'number'
  issue_sms_text:             DS.attr 'string'
  manual_issue_enabled:       DS.attr 'boolean'
  late_issue_enabled:         DS.attr 'boolean'
  late_issue_minutes_amount:  DS.attr 'number'


  # скидка на блюда, указанные в списке, а не на весь заказ
  dishes_price_multiplier: DS.attr 'number'
  dishes_price_multiplier_single_dish: DS.attr 'boolean'
  dishes_price_multiplier_single_dish_cheapest: DS.attr 'boolean'

  # параметры для акции "последний заказ"
  next_order_in_days: DS.attr 'number'
  next_order_min_sum: DS.attr 'number'

  # условия hasMany
  clients:                        DS.hasMany 'client',     async: true
  client_tags:                    DS.hasMany 'client_tag', async: true
  codes:                          DS.hasMany 'promo_code', async: true
  required_all_dishes:            DS.hasMany 'dish',       async: true
  required_any_dishes:            DS.hasMany 'dish',       async: true
  required_any_dish_categories:   DS.hasMany 'category',       async: true

  client_bonus_reset_tags: DS.hasMany 'client_tag', async: true
  client_restrict_tags:    DS.hasMany 'client_tag', async: true

  required_any_dishes_count: DS.attr 'number'

  restaurants:       DS.hasMany 'restaurant', async: true

  # бонусы
  bonus_summand:     DS.attr 'number'
  bonus_multiplier:  DS.attr 'number'
  bonus_issue_promo: DS.belongsTo 'promo',      async: true
  bonus_client_tag:  DS.belongsTo 'client_tag', async: true
  bonus_dishes:      DS.hasMany 'dish',         async: true
  bonus_free_dishes: DS.hasMany 'dish',         async: true

  # цена бонусных блюд
  bonus_price:       DS.attr 'number'
  sources:           DS.attr 'string'
  recurrences:       DS.attr 'string'

  # промокоды
  promo_codes_enabled:    DS.attr 'boolean', async: true
  promo_codes_available:  DS.attr 'number', async: true
  promo_codes_used:       DS.attr 'number', async: true

  promo_codes_unused: ( ->
    @get('promo_codes_available') - @get('promo_codes_used')
  ).property('promo_codes_used', 'promo_codes_available')


  organization: DS.belongsTo 'organization', async: true

  # ---
  # Свойство-конвертор из процентной записи в относительную
  # ---
  discountPercent: ((key, value) ->
    mul = @get('bonus_multiplier')
    percent = null

    if arguments.length > 1
      v = Number( value )

      if isNaN(v) or v < 0.0 or v > 100.0
        mul = null
      else
        mul = v / (-100.0)

      @set('bonus_multiplier', mul)

    percent = if mul then Math.round(-100.0 * mul) else ''
  ).property('bonus_multiplier')

  # ---
  # Свойство-конвертор из процентной записи в относительную
  # Копипаст для другой скидки
  # ---
  discountDishesPercent: ((key, value) ->
    mul = @get('dishes_price_multiplier')
    percent = null

    if arguments.length > 1
      v = Number( value )

      if isNaN(v) or v < 0.0 or v > 100.0
        mul = null
      else
        mul = v / (-100.0)

      @set('dishes_price_multiplier', mul)

    percent = if mul then Math.round(-100.0 * mul) else ''
  ).property('dishes_price_multiplier')

  bonusSummandPositive: ((key, value) ->
    mul = @get('bonus_summand')

    if arguments.length > 1
      v = Math.abs(Number( value ))
      return @set('bonus_summand', -1 * v)

    mul * -1
  ).property('bonus_summand')

  sources_array: ((key, value, oldValue)->
    if arguments.length == 1
      return [] unless @get('sources')
      return @get('sources').split(',')
    else
      @set 'sources', value.join(',')
      return value
  ).property('sources')

  recurrences_array: ((key, value, oldValue)->
    if arguments.length == 1
      return [] unless @get('recurrences')
      return @get('recurrences').split(',')
    else
      @set 'recurrences', value.join(',')
      return value
  ).property('recurrences')

  deliveryTypeSelected: (->
    @get('is_dine_in') || @get('is_takeaway') || @get('is_delivery')
  ).property('is_dine_in', 'is_takeaway', 'is_deivery')

  issue: (client_id)->
    @nonRESTAction('POST', 'issue_to_client', {client_id})
